























































































import { calcProgn } from '@/modules/budget-request/components/js/budgetCalcProgn';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { Component, Vue, Prop } from 'vue-property-decorator';
import store from '@/services/store';
import { setNameLang, makeToast } from '@/modules/budget-request/components/js/some-functions';
import { getBudgetText }  from '@/modules/budget-request/components/budget-sum-calc/js/budget-translation';
import CAddModal from '@/modules/budget-request/budget-gkkp/c-add-modal.vue';
import CNumberInput from '@/components/c-number-input/index.vue';

@Component({
    name: 'c-bud-sum-calc-income-tab',
    components: {
        'c-add-modal': CAddModal,
        'c-number-input': CNumberInput
    }
})
export default class CBudgetSumCalcIncomeTab extends Vue {
    @Prop({
        required: true,
        default: {}
    })
    private filter!: any;

    @Prop({
        required: false,
        default: true
    })
    private edited!: boolean;

    private firstEdit = false; // началось ли редактирование

    private progress = 0;
    private curYear = (new Date()).getFullYear();

    private curDataType: string | null = null;
    private curGr: number | null = null;
    private curAbp: number | null = null;
    private curGu: string | null = null;
    private curProg: number | null = null;
    private curSubProg: number | null = null;
    // подпрограмма не пришла из фильтра (справочник не ответил или ещё грузится) - не то же самое,
    // что "у программы нет подпрограмм": там приходит пункт со ppr = null. редактирование закрываем
    private pprUnknown = false;
    private region = '450101';
    private variantEndDate: any | null = null;
    private variantStartDate: any | null = null;

    private calcData: any = [];
    private curVariant: string | null = null;
    private versYear: number | null = null;

    private totalSum: any = { 'kass_sum': 0, 'fact_sum': 0, 'utoch_plan': 0, planVal0: 0, planVal1: 0, planVal2: 0 };

    private categoryBase: any[] = [];

    private mounted() {
        if (this.filter) { this.chgFilter(this.filter); }

        this.$watch('firstEdit', async () => {
            this.$emit('changed', this.firstEdit);
        });
        this.loadDictGuIncome();
    }

    private get usrId(): string | null {
        if (!store.state.user.sub) { return null; }
        return store.state.user.sub;
    }

    private async loadDictGuIncome() {
        try {
            const response = await fetch('/api-py/load-gict-gu-income');
            if (response.status === 200) {
                const result = await response.json();
                this.categoryBase = result;
            } else {
                this.categoryBase = [];
                makeToast(this, 'danger', 'Ошибка загрузки категорий', `${response.status} - ${response.statusText}`);
            }
        } catch (error) {
            this.categoryBase = [];
            makeToast(this, 'danger', 'Ошибка загрузки категорий', (error as Error).toString());
        }
    }

    // добавить категорию
    private addCat() {
        const dictLst = [];
        for (const el of this.categoryBase) {
            let fl = false;
            for (let i = 0; i < this.calcData.length; i++) {
                if (this.calcData[i].incomeCat.code === el.code) {
                    fl = true;
                    break;
                }
            }
            if (!fl) { dictLst.push(el); }
        }

        // eslint-disable-next-line
        // @ts-ignore
        this.$refs.addModalRef.openModal(dictLst);
    }

    private async loadData() {
        this.firstEdit = false;
        this.progress = 25;
        this.totalSum = { 'kass_sum': 0, 'fact_sum': 0, 'utoch_plan': 0, planVal0: 0, planVal1: 0, planVal2: 0 };
        if (!this.curVariant) {
            makeToast(this, 'warning', this.tblTitle.load_data, this.tblTitle.not_selected_vers);
            this.progress = 0;
            return;
        }
        // подпрограмма недостоверна - данные не грузим
        if (this.pprUnknown) {
            makeToast(this, 'warning', this.tblTitle.load_data, this.tblTitle.not_selected_ppr);
            this.progress = 0;
            return;
        }
        if (!this.curGu) {
            makeToast(this, 'warning', this.tblTitle.load_data, this.tblTitle.not_selected_gu);
            this.progress = 0;
            return;
        }
        const params = { curYear: this.curYear, abp: this.curAbp, dataType: this.curDataType, gr: this.curGr, gu: this.curGu, prg: this.curProg, ppr: this.curSubProg, region: this.region, variant: this.curVariant, locale: this.$i18n.locale, vers_year: this.versYear, date_b: this.variantStartDate, date_e: this.variantEndDate };
        let result = [];
        try {
            const response: any = await fetch(`/api-py/get-budget-consolidate-expens-income/${encodeURI(JSON.stringify(params))}`);
            result = await response.json();
            for (const el of result) {
                el.planVal0 = el.planVal0 ? parseFloat(el.planVal0): 0;
                el.planVal1 = el.planVal1? parseFloat(el.planVal1): 0;
                el.planVal2 = el.planVal2? parseFloat(el.planVal2): 0;
                el.kass_sum = el.kass_sum? parseFloat(el.kass_sum): 0;
                el.utoch_plan = el.utoch_plan? parseFloat(el.utoch_plan): 0;
                el.fact_sum = el.fact_sum? parseFloat(el.fact_sum): 0;
                el.oldData = {
                    planVal0: el.planVal0,
                    planVal1: el.planVal1,
                    planVal2: el.planVal2,
                    kass_sum: el.kass_sum,
                    utoch_plan: el.utoch_plan,
                    fact_sum: el.fact_sum
                }
                this.totalSum.kass_sum += el.kass_sum;
                this.totalSum.utoch_plan += el.utoch_plan;
                this.totalSum.fact_sum += el.fact_sum;
                this.totalSum.planVal0 += el.planVal0;
                this.totalSum.planVal1 += el.planVal1;
                this.totalSum.planVal2 += el.planVal2;
            }
            this.calcData = result;
            this.progress = 100;
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка get-req-total', (error as Error).toString());
            this.progress = 0;
            return;
        }
    }

    // редактирование разрешено, только если подпрограмма получена из справочника
    private get editAllowed(): boolean {
        return this.edited && !this.pprUnknown;
    }

    private async save() {
        if (this.pprUnknown) {
            makeToast(this, 'warning', this.tblTitle.saving, this.tblTitle.not_selected_ppr);
            return;
        }
        // ---
        const saveObj: any[] = [];
        for (const el of this.calcData) {
            // eslint-disable-next-line @typescript-eslint/camelcase
            el.fact_sum = this.truncateDecimal(el.fact_sum);
            // eslint-disable-next-line @typescript-eslint/camelcase
            el.utoch_plan = this.truncateDecimal(el.utoch_plan);
            // eslint-disable-next-line @typescript-eslint/camelcase
            el.kass_sum = this.truncateDecimal(el.kass_sum);
            el.planVal0 = this.truncateDecimal(el.planVal0);
            el.planVal1 = this.truncateDecimal(el.planVal1);
            el.planVal2 = this.truncateDecimal(el.planVal2);
            if (el.id < 0) {
                if (el.fact_sum || el.utoch_plan || el.kass_sum || el.planVal0 || el.planVal1 || el.planVal2) {
                    saveObj.push(Object.assign({ region: this.region, userId: this.usrId, variant: this.curVariant, income_cat: el.incomeCat.code }, el));
                }
            } else if (this.isChanged(el)) {
                delete el.oldData;
                saveObj.push(Object.assign({ userId: this.usrId, income_cat: el.incomeCat.code }, el));
            }
        }

        if (!saveObj.length) {
            makeToast(this, 'warning', this.tblTitle.saving, this.tblTitle.no_changes);
            this.loadData();
            return;
        }
        try {
            const url = '/api-py/save-budget-consolidate-expens-income';
            let response: any = await fetch(url, {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
                body: JSON.stringify(saveObj)
            });
            response = await response.json();
            let success = true;
            let errTxt = '';
            for (const r of response) {
                if (r.result !== 'success') {
                    success = false;
                    // текст первой ошибки, а не слово "error" первого элемента пачки. один тост на сохранение
                    if (!errTxt) { errTxt = r.errTxt ? r.errTxt : r.result; }
                }
            }
            if (success) { makeToast(this, 'success', this.tblTitle.saving, this.tblTitle.data_saved); } else { makeToast(this, 'danger', this.tblTitle.saving, errTxt); }
            this.loadData();
        } catch (error) {
            makeToast(this, 'danger', 'Ошибка сохранения', (error as Error).toString());
        }
        // ---
        this.firstEdit = false;
    }

    private isChanged(el: any): boolean { // проверка изменений
        if (el.fact_sum !== el.oldData.fact_sum) { return true; }
        if (el.utoch_plan !== el.oldData.utoch_plan) { return true; }
        if (el.kass_sum !== el.oldData.kass_sum) { return true; }
        if (el.planVal0 !== el.oldData.planVal0) { return true; }
        if (el.planVal1 !== el.oldData.planVal1) { return true; }
        if (el.planVal2 !== el.oldData.planVal2) { return true; }
        return false;
    }

    private addModalClk(items: any[]) {
        for (const item of items) {
            const newObj = {
                incomeCat: { code: item.code, name: item.name },
                kass_sum: 0,
                fact_sum: 0,
                utoch_plan: 0,
                planVal0: 0,
                planVal1: 0,
                planVal2: 0,
                id: -1,
                'cur_year': this.curYear,
                'data_type': this.curDataType,
                abp: this.curAbp,
                gr: this.curGr,
                gu: this.curGu,
                prg: this.curProg,
                ppr: this.curSubProg
            }
            this.calcData.push(newObj)
        }
        this.calcData.sort((a: any, b: any) => (a.incomeCat.code > b.incomeCat.code) ? 1 : -1);
        if (!this.firstEdit) { this.firstEdit = true; }
    }

    // усечение (не округление) дробной части до 1 знака после запятой
    private truncateDecimal(value: any): number {
        const num = parseFloat(String(value));
        if (isNaN(num)) { return 0; }
        const str = String(num);
        const dotIdx = str.indexOf('.');
        if (dotIdx === -1) { return num; }
        return parseFloat(str.slice(0, dotIdx + 2));
    }

    private chgValue(obj: any, fieldName: string) {
        if (parseFloat(String(obj[fieldName])).isNaN) { obj[fieldName] = 0; }
        obj[fieldName] = this.truncateDecimal(obj[fieldName]);
        this.totalSum = { 'kass_sum': 0, 'fact_sum': 0, 'utoch_plan': 0, planVal0: 0, planVal1: 0, planVal2: 0 };
        for (const el of this.calcData) {
            // eslint-disable-next-line @typescript-eslint/camelcase
            this.totalSum.kass_sum += Math.round(parseFloat(el.kass_sum) * 100) / 100;
            // eslint-disable-next-line @typescript-eslint/camelcase
            this.totalSum.fact_sum += Math.round(parseFloat(el.fact_sum) * 100) / 100;
            // eslint-disable-next-line @typescript-eslint/camelcase
            this.totalSum.utoch_plan += Math.round(parseFloat(el.utoch_plan) * 100) / 100;
            if (el.planVal1) { this.totalSum.planVal1 += Math.round(parseFloat(el.planVal1) * 100) / 100; }
            if (el.planVal2) { this.totalSum.planVal2 += Math.round(parseFloat(el.planVal2) * 100) / 100; }
            if (el.planVal0) { this.totalSum.planVal0 += Math.round(parseFloat(el.planVal0) * 100) / 100; }
        }
        if (!this.firstEdit) this.firstEdit = true;
    }

    /**
     * ввод цифр (доп. ограничение поверх c-number-input: не более 1 знака после запятой/точки)
     */
     private noAbc(evt: any) {
        const key = String.fromCharCode(!evt.charCode ? evt.which : evt.charCode);
        // eslint-disable-next-line require-unicode-regexp
        const digitRegex = new RegExp('^\\d$');
        if (!digitRegex.test(key)) { return; }
        const input = evt.target as HTMLInputElement;
        const value = input.value;
        const start = input.selectionStart ?? value.length;
        const end = input.selectionEnd ?? value.length;
        const sepIdx = value.search(/[.,]/u);
        if (sepIdx === -1 || start !== end) { return; }
        // курсор сразу после запятой/точки, дробная часть - единственный "0": заменяем его вводимой цифрой
        if (start === sepIdx + 1 && value[start] === '0' && start === value.length - 1) {
            evt.preventDefault();
            const newValue = value.slice(0, start) + key + value.slice(start + 1);
            input.value = newValue;
            input.setSelectionRange(start + 1, start + 1);
            input.dispatchEvent(new Event('input'));
            return;
        }
        // ограничение в 1 знак после запятой/точки (пробелы - разделители тысяч, не считаются)
        if (start > sepIdx) {
            const decimalsAfter = value.slice(sepIdx + 1).replace(/\s/gu, '').length;
            if (decimalsAfter >= 1) {
                evt.preventDefault();
            }
        }
    }

    private async chgFilter(filter: any) {
        this.curAbp = filter.abp.abp;
        this.region = filter.region.code;
        this.curYear = parseInt(filter.curYear);
        this.curDataType = filter.dataType.code;
        this.curGr = filter.gr;
        this.variantEndDate = filter.variantEndDate;
        this.versYear = null;
        if (filter.curVariant) {
            this.curVariant = filter.curVariant.variant_uuid;
            this.variantStartDate = filter.curVariant.date_start;
            this.versYear = (this.curDataType == '2' ? filter.curVariant.year: null);
        }
        if (filter.gu !== null) { this.curGu = filter.gu.code; } else { this.curGu = null; }
        if (filter.prg !== null) { this.curProg = filter.prg.prg; } else { this.curProg = null; }
        if (filter.ppr !== null) { this.curSubProg = filter.ppr.ppr; } else { this.curSubProg = null; }
        this.pprUnknown = (filter.ppr === null);
        this.calcData = [];
        this.loadData();
    }

    // ---- переводы
    private getBudgetText(link: string) {  return getBudgetText(link); }

    private get tblTitle() {
        const obj = {
            code: this.getBudgetText('sum_calc_edit.code'), // Код
            name: this.getBudgetText('sum_calc_edit.name'), // Наименование
            for_year: [
                this.getBudgetText('sum_calc_edit.for_year[0]'), // Отчет на
                this.getBudgetText('sum_calc_edit.for_year[1]'), // год
            ],
            kasRas: this.getBudgetText('sum_calc_abp.kasRas'), // Кассовые расходы
            factRas: this.getBudgetText('sum_calc_abp.factRas'), // Фактические расходы
            uochPlan_for: {
                val0: this.getBudgetText('sum_calc_abp.uochPlan_for.val0'), // Уточненный план на
                val1: this.getBudgetText('sum_calc_abp.uochPlan_for.val1'), //
            },
            planned_period: this.getBudgetText('sum_calc_edit.planned_period'), // Планируемый плановый период
            year: this.getBudgetText('sum_calc_abp.year'), // г.
            totalCost: this.getBudgetText('sum_calc_abp.totalCost'), // Всего затрат (тыс. теңге)
            choose_spec: this.getBudgetText('sum_calc_edit.choose_spec'), // Выберите специфику
            saving: this.getBudgetText('sum_calc_edit.saving'), // Сохранение
            data_saved: this.getBudgetText('sum_calc_edit.data_saved'), // Данные сохранены
            no_changes: this.getBudgetText('sum_calc_edit.no_changes'), // Нет изменений для сохранения
            load_data: this.getBudgetText('sum_calc_edit.load_data'), // Загрузка данных
            not_selected_gu: this.getBudgetText('sum_calc_edit.not_selected_gu'), // Не выбрано гос.учреждение
            not_selected_vers: this.getBudgetText('sum_calc_edit.not_selected_vers'), // Не выбрана версия бюджета
            not_selected_ppr: this.getBudgetText('sum_calc_edit.not_selected_ppr'), // Не получен список подпрограмм - редактирование недоступно
        };
        return obj;
    }
}
